import styled from 'styled-components';

export const ChartContainer = styled.div`
  height: 200px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #EDEDED;
  padding: 10px;
`;

export const PopoverContentWrapper = styled.div`
  height: 100%;
  max-height: 800px;
  border-radius: 2px;
  max-width: 400px;
  position: relative;
  border: 1px solid #EDEDED;
`;

export const ButtonFooter = styled.a`
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 12px;
  align-items: center;
`;

export const CompanySymbol = styled.div`
  background: #333333;
  border-left: 5px solid #00AB6B;
  height: 30px;
  border-radius: 2px;
`;

export const SuspendedBadge = styled.div`
  position: absolute;
  display: flex;
  padding: 2px 5px;
  color: #EE4A49;
  border: 1px solid rgba(238, 74, 73, 0.5);
  border-radius: 2px;
  top: 12px;
  left: 12px;
`;
